<div class="c-testerModal">
  <div class="c-testerModal__container">
    <div class="c-testerModal__content">
      <fieldset>
        <legend>Set Console Log Level</legend>

        <div class="e-form">
          <form
            [formGroup]="logLevelForm"
            (ngSubmit)="onSubmitLogLevel()">
            <div class="e-form">
              <div class="e-form__field">
                <div class="e-form__element__row">
                  <label>Log level</label>

                  <slotcom-select
                    formControlName="selectedLogLevel"
                    placeholder="Select log level">
                    <slotcom-select-option [value]="LogLevel.All">All</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Debug">Debug</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Error">Error</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Fatal">Fatal</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Info">Info</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Warn">Warn</slotcom-select-option>
                    <slotcom-select-option [value]="LogLevel.Off">Off</slotcom-select-option>
                  </slotcom-select>
                </div>

                <div class="e-form__element__button__row">
                  <slotcom-button
                    class="c-button--pink"
                    (click)="onSubmitLogLevel()">
                    {{ 'home.buttons.go' | translate | uppercase }}
                  </slotcom-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </fieldset>

      <fieldset>
        <legend>Audio Controls</legend>
        <slotcom-test-panel-audio></slotcom-test-panel-audio>
      </fieldset>
    </div>
  </div>
</div>
